const emailStatusMap = {
  2: 'Engagement Leader',
  3: 'Engagement Leader - Pending to Completed',
  4: 'Manager',
  5: 'Manager - Pending to Completed',
  6: 'Reviewer',
  7: 'Reviewer - Pending to Completed',
  8: 'EL',
  9: 'RQR Leader',
}

export default rqrTypeCode => emailStatusMap[rqrTypeCode] || 'Status not mapped yet'

export { emailStatusMap }
